module.exports = __webpack_public_path__ + "img/follow-the-rules-ua.036f5f59.png";